import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

interface ImageDragDropWithPreviewProps {
  onChange: (newImage: File) => void;
  label: string;
  previewImageUrl?: string;
}
const ImageDragDropWithPreview = (props: Readonly<ImageDragDropWithPreviewProps>) => {
  const [previewUrl, setPreviewUrl] = useState<string>(props.previewImageUrl ?? '');
  const handleImageDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setPreviewUrl(URL.createObjectURL(file));
      props.onChange(file);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png']
    },
    onDrop: handleImageDrop,
  });

  return (
    <>
      <label className="block text-sm font-medium leading-6 text-gray-900">{props.label}</label>
      <div className="mt-2">
        <div {...getRootProps()} className={`border border-2 border-dashed border-gray-300 rounded-md p-5 text-center cursor-pointer ${previewUrl ? 'h-48' : 'h-18'}`}>
          <input {...getInputProps()} />
          {previewUrl ? (
            <img src={previewUrl} alt={`${props.label} Preview`} className="max-w-xs max-h-36 mx-auto" />
          ) : (
            <p>Drag 'n' drop an image here, or click to select one</p>
          )}
        </div>
      </div>
    </>
  );
};

export default ImageDragDropWithPreview;
